import state from './state';
import * as mutations from './mutations';
import * as actions from  './actions'

export default {
  namespaced: true,
  actions,
  mutations,
  state
}


// WEBPACK FOOTER //
// ./src/modules/public-invoice/index.js